import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { BasketButtonError } from '@as-react/common-types';
import { InfoIcon } from '@yonderland/andes-icons';
import { Box, Chip, Icon, StackBlock, StackInline, TextAlpha, useBreakpoints } from '@yonderland/andes-react';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { PRODUCT_SIZE_CHIP_INNER_PADDING } from '../../../constants/ProductConstants';
import { getSizeButtonsError } from '../../../util/ProductUtil';
import { ScrollUtil } from '../../../util/ScrollUtil';
export const SizeSelectButtonsFull = ({ id, selectedSku, selectSize, isNotifyMeSizeError, options, filteredSizes, basketValidationState, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { isLg, isXl, is2xl } = useBreakpoints();
    const isDesktop = isLg || isXl || is2xl;
    const selectedSize = selectedSku && filteredSizes.find(option => option.sku === selectedSku);
    const [errorMessage, setErrorMessage] = useState();
    const { isShopLanding } = useAemConfig();
    const chipSize = `${Math.max(...options.map(s => s.label.toString().length)) + 2}ch + ${PRODUCT_SIZE_CHIP_INNER_PADDING}px`;
    useEffect(() => {
        if (basketValidationState === BasketButtonError.SKU_OPEN_SIZE_SELECT ||
            basketValidationState === BasketButtonError.SKU ||
            isNotifyMeSizeError) {
            ScrollUtil.scrollToErrorElement(document.getElementById(id), isDesktop, () => {
                setErrorMessage(getSizeButtonsError(basketValidationState));
            });
        }
    }, [basketValidationState]);
    const getButtonState = (option) => {
        if (option.disabled)
            return 'disabled';
        if (errorMessage && (!option.isSoldOut || (option.isSoldOut && isNotifyMeSizeError)))
            return 'error';
        if (option.value === selectedSku)
            return 'activated';
        return 'resting';
    };
    const handleButtonClick = (option) => () => {
        if (option.disabled)
            return;
        setErrorMessage(undefined);
        selectSize({ sku: option.value.toString(), isSoldOut: option.isSoldOut });
    };
    const buttonOptions = useMemo(() => options.map(option => (_jsx(Chip, { state: getButtonState(option), text: option.label, strikethrough: isShopLanding ? option.disabled : option.isSoldOut, onClick: option.disabled ? undefined : handleButtonClick(option), size: "md", variant: isShopLanding && option.disabled ? 'secondary' : undefined }, option.value.toString()))), [options]);
    return (_jsxs(StackBlock, { id: id, testId: id, gap: "2", children: [options.length ? (selectedSize &&
                selectedSize.fullCommercialSize &&
                !options.find(size => size.label === selectedSize.fullCommercialSize) ? (_jsxs(StackInline, { gap: "2", itemsAlign: "baseline", children: [_jsx(TextAlpha, { strong: true, children: t('pdp.size.buttons.label') }), _jsx(TextAlpha, { children: selectedSize.fullCommercialSize })] })) : (_jsx(TextAlpha, { strong: true, children: t('pdp.size.buttons.label') }))) : null, _jsx(Grid, { scalable: {
                    min: `calc(${chipSize})`,
                    maxCols: options.length <= 2 ? { mobile: 2, desktop: 3 } : { mobile: 4, desktop: 6 },
                    repeatPattern: options.length <= 2 ? 'auto-fill' : undefined,
                }, gap: "s", dataQA: "size-select-buttons", children: buttonOptions }), errorMessage && (_jsxs(StackInline, { gap: "1", wrap: "nowrap", children: [_jsx(Box, { paddingBlockStart: "1", children: _jsx(Icon, { source: InfoIcon, color: "error", size: "xs" }) }), _jsx(TextAlpha, { color: "error", children: t(errorMessage) })] }))] }));
};
